/*** IMPORTS FROM imports-loader ***/
var define = false;

import { hasOwnProperty } from './_setup.js';

// Internal function to check whether `key` is an own property name of `obj`.
export default function has(obj, key) {
  return obj != null && hasOwnProperty.call(obj, key);
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_has.js
// module id = 10
// module chunks = 0